// Diverse USP-Keywords zur Rotation über alle Seiten – vermeidet "Festpreis"-Wiederholung.
// Jede Seite erhält deterministisch denselben USP (SEO-Stabilität), aber über alle
// ~2000 Seiten verteilt wechseln sich verschiedene Keywords ab.

const movingUsps = [
  { title: 'Transparente Offerte', desc: 'klar aufgeführte Leistungen und Preise' },
  { title: 'Betriebshaftpflicht', desc: 'Betriebshaftpflicht bis CHF 5 Mio.' },
  { title: 'Faire Preise', desc: 'Stunden- oder Festpreis nachvollziehbar offeriert' },
  { title: 'Kostenlose Besichtigung', desc: 'kostenlose Besichtigung vor Ort oder per Video' },
  { title: 'Zuverlässig & Schnell', desc: 'sorgfältige Planung und termingerechte Durchführung' },
  { title: 'Kundenorientiert', desc: 'persönliche Beratung und klare Kommunikation' },
  { title: 'Erfahrenes Team', desc: 'eingespieltes Team und geeignete Ausrüstung' },
  { title: 'Sicherer Möbeltransport', desc: 'Schutzmaterial und Transportdeckung gemäss Offerte' },
  { title: 'Schriftliche Offerte', desc: 'vereinbarter Leistungsumfang schriftlich festgehalten' },
  { title: 'Regional & Zuverlässig', desc: 'regional verwurzelt, zuverlässig und fair' },
  { title: 'Fair & Transparent', desc: 'klare Preise und nachvollziehbare Leistungen' },
  { title: 'Sorgfältig & Pünktlich', desc: 'sorgfältige Vorbereitung und pünktliches Team' },
];

const cleaningUsps = [
  { title: 'Abnahmegarantie', desc: 'Abnahmegarantie & verbindlicher Festpreis' },
  { title: 'Festpreis', desc: 'Festpreis mit schriftlicher Abnahmegarantie' },
  { title: 'Besenkehrrein Garantiert', desc: 'besenkehrrein garantiert, Festpreis' },
  { title: 'Betriebshaftpflicht', desc: 'Betriebshaftpflicht und Abnahmegarantie nach Offerte' },
  { title: 'Transparente Preise', desc: 'transparente Preise, Abnahmegarantie inklusive' },
  { title: 'Kostenlose Besichtigung', desc: 'kostenlose Besichtigung & Festpreis' },
  { title: 'Zuverlässig', desc: 'zuverlässig, mit Abnahmegarantie' },
  { title: 'Top-Bewertungen', desc: 'Kundenbewertungen und Abnahmegarantie' },
  { title: 'Festpreis & Garantie', desc: 'Festpreis & Abnahmegarantie aus einer Hand' },
  { title: 'Professionell', desc: 'professionelle Reinigung mit Abnahmegarantie' },
];

// Deterministischer Hash – gleiche Stadt + Service = gleicher USP (wichtig für SEO-Stabilität)
function hashStr(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = ((h << 5) - h) + str.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
}

export function getUsp(city, serviceType) {
  const isCleaning = serviceType === 'reinigungsfirma' || serviceType === 'umzugsreinigung';
  const pool = isCleaning ? cleaningUsps : movingUsps;
  return pool[hashStr(city + serviceType) % pool.length];
}

// Für City-Service-Seiten (Umzug {city}) – nutzt allgemeine Moving-USPs
export function getCityUsp(city) {
  return movingUsps[hashStr(city + 'city') % movingUsps.length];
}

// Liefert einen stabilen Index 0..count-1 für Why/FAQ-Rotation pro Stadt+Service
export function getVariationIndex(city, serviceType, count) {
  return hashStr(city + serviceType + 'variation') % count;
}

// FAQ-Sets für Stadt-Seiten (Umzug {city}) – 3 Variationen zur Rotation
export function getCityFaqs(city) {
  const sets = [
    [
      { q: `Was kostet ein Umzug in ${city}?`, a: `Die Kosten hängen von der Wohnungsgrösse, dem Stockwerk und den gewünschten Services ab. Ein kleiner Umzug (Studio) beginnt ab CHF 480.–, ein 3-Zimmer-Umzug ab ca. CHF 1'100.– bis CHF 1'300.–. Nutzen Sie unseren kostenlosen Kostenrechner oder fordern Sie eine unverbindliche Offerte an.` },
      { q: `Bietet Umzug City Festpreise in ${city} an?`, a: `Ja! Wir arbeiten ausschliesslich mit Festpreisen. Nach einer kostenlosen Besichtigung erhalten Sie ein verbindliches Angebot ohne versteckte Kosten.` },
      { q: `Wie kurzfristig kann ich einen Umzug in ${city} buchen?`, a: `Wir empfehlen, 2–4 Wochen im Voraus zu buchen. Bei dringenden Umzügen in ${city} versuchen wir jedoch immer kurzfristig zu helfen. Rufen Sie uns an: 044 514 33 66.` },
      { q: `Macht Umzug City auch Firmenumzüge in ${city}?`, a: `Ja, wir führen Firmenumzüge aller Grössen in ${city} und der ganzen Region durch – von kleinen Büros bis hin zu grossen Unternehmen. Wir arbeiten auch am Wochenende und ausserhalb der Geschäftszeiten.` },
    ],
    [
      { q: `Was kostet ein Umzug mit Umzug City in ${city}?`, a: `Ein Studio-Umzug in ${city} startet ab CHF 480.–, ein 3-Zimmer-Umzug liegt zwischen CHF 1'100.– und CHF 1'300.–. Der exakte Festpreis wird nach kostenloser Besichtigung verbindlich festgelegt – ohne versteckte Kosten.` },
      { q: `Sind die Preise in ${city} verbindlich?`, a: `Ja. Nach der kostenlosen Besichtigung in ${city} erhalten Sie einen schriftlichen, verbindlichen Festpreis. Keine Überraschungen, keine versteckten Aufschläge.` },
      { q: `Kann ich in ${city} auch kurzfristig umziehen?`, a: `Wir empfehlen 2–4 Wochen Vorlauf, bemühen uns aber, auch kurzfristige Umzüge in ${city} zu realisieren. Kontaktieren Sie uns unter 044 514 33 66.` },
      { q: `Bietet Umzug City in ${city} auch Geschäftsumzüge an?`, a: `Selbstverständlich. In ${city} führen wir Firmenumzüge jeder Grösse durch – auch am Wochenende oder nachts, damit Ihr Geschäftsbetrieb nicht gestört wird.` },
    ],
    [
      { q: `Wie teuer ist ein Umzug in ${city}?`, a: `Die Kosten in ${city} hängen von Wohnungsgrösse, Stockwerk und Zusatzleistungen ab. Ein kleiner Umzug ab CHF 480.–, ein 3-Zimmer-Umzug ab ca. CHF 1'100.– bis 1'300.–. Fordern Sie eine kostenlose Offerte an.` },
      { q: `Gibt es in ${city} eine Festpreisgarantie?`, a: `Ja. Wir erstellen nach einer kostenlosen Besichtigung in ${city} ein schriftliches, verbindliches Angebot – Festpreisgarantie ohne versteckte Kosten.` },
      { q: `Wie viel Vorlauf braucht ein Umzug in ${city}?`, a: `Wir empfehlen 2–4 Wochen Vorlauf. Für dringende Umzüge in ${city} finden wir jedoch oft kurzfristig eine Lösung. Rufen Sie uns an: 044 514 33 66.` },
      { q: `Übernimmt Umzug City auch Büroumzüge in ${city}?`, a: `Ja. In ${city} führen wir Firmenumzüge vom kleinen Büro bis zum ganzen Unternehmen durch – flexibel am Wochenende oder ausserhalb der Geschäftszeiten.` },
    ],
  ];
  return sets[hashStr(city + 'cityfaq') % sets.length];
}